export default {
    about_management: 'Об управлении',
    ppp_objects: 'Объекты ГЧП',
    realized_objects: 'Реализованные объекты',
    notfound:'Нет активных лотов',
    private_schools: 'Частные школы',
    faq: 'FAQ',
    contact_us: 'Свяжитесь с нами',
    ministry: 'Министерство дошкольного и школьного образования Республики Узбекистан',
    ministry_footer: 'Министерство дошкольного и школьного образования Республики Узбекистан',
    department: 'Управления перспективных моделей школ и государственно-частного партнерства',
    active: 'Активные',
    active_1: 'Активный',
    offered: 'Предлагаемые',
    proposed_1: 'Предлагаемый',
    select_district: 'Выберите районы',
    select_category: 'Выберите категории',
    select_type: 'Выберите типы',
    select_region: 'Выберите регион',
    date_from: 'От',
    date_to: 'До',
    more_info: 'Подробнее',
    expDate: 'Дата окончания',
    search: 'Поиск',
    faqfull: 'Часто задаваемые вопросы',
    read: 'Читать',
    news: 'Новости',
    count: 'количество',
    active_objects: 'Активные объекты',
    site_map: 'Карта сайта',
    webeonmark: 'Сайт разработал',
    main_page: 'Главная',
    your_fullname: 'Ваше полное имя',
    name: 'Имя',
    lastname: 'Фамилия',
    organization: 'Организация',
    your_phone: 'Ваш номер телефона',
    code: 'Код',
    your_email: 'Ваша эл. почта',
    message: 'Ваше сообщение',
    send: 'Отправить',
    close: 'Закрыть',
    city_title: 'Объекты ГЧП по',
    school: 'Школа №',
    contacts: 'Контакты',
    phone: 'Номер телефона',
    address: 'Адрес',
    full_address: '100187, город Ташкент, Шайхантахурский район, улица Навои, 2а',
    email: 'Эл. почта',
    website: 'Веб сайт',
    contact_number: 'Контактный телефон',
    working_time: 'Режим работы управления',
    monday: 'Пн',
    tuesday: 'Вт',
    wednesday: 'Ср',
    thursday: 'Чт',
    friday: 'Пт',
    saturday: 'Сб',
    sunday: 'Вс',
    aboutfull_1: 'Деятельность управления перспективных моделей школ и государственно-частного партнерства сосредоточена на проведении исследований и оценки реализации инвестиционных проектов ГЧП в сфере народного образования. Мы обеспечиваем полное консультационное сопровождение проектов и содействуем их реализации. Важная часть нашей работы – формирование базы и содействие в реализации проектов.',
    aboutfull_2: 'Мы эффективно взаимодействуем с органами законодательной и исполнительной власти, местными компаниями и международными и общественными организациями. Основной задачей управления является создание условий для партнерства между государством и бизнесом, развитии и объединении их потенциала для реализации проектов ГЧП и увеличения объема частных инвестиций в экономику страны.',
    city: 'Город/область',
    district: 'Район',
    legal_address: 'Юридический адрес объекта',
    total_area: 'Общая площадь, кв.м',
    building_area: 'Площадь под зданием, кв.м',
    used_area: 'Исползуемая площадь, кв.м',
    free_land_area: 'Свободная земельная плошадь, кв.м',
    problems: 'Существующие проблемы в школе',
    status: 'Cтатус',
    language_of_instruction: 'Язык обучения',
    opening_date: 'Дата открытия',
    established: 'Дата основания',
    admission_terms: 'Условия приема',
    training_duration: 'Длительность обучения',
    training_duration_1: 'Длител. обучения',
    language_learning: 'Язык обучения',
    specialization: 'Специализация',
    local_teachers: 'Препод. состав местный',
    foreign_teachers: 'Препод. состав зарубежный',
    sport_ground: 'Спортивная площадка',
    security: 'Охрана',
    transport: 'Транспорт (автобус)',
    school_hallmark: 'Отличительная черта школы',
    payment_for_month: 'Оплата за один месяц обучения',
    discount: 'Скидка',
    schoolbook: 'Обеспеч. учебн. пособиям',
    food: 'Питание ',
    extraClasses: 'Дополнительные кружки ',
    status_0: 'Отсутствует',
    status_1: 'Есть',
    titleProblem: 'Описание',
    successful_message: 'Спасибо, Ваше сообщение отправлено Модератору на рассмотрение. Мы свяжемся с Вами в ближайшее время.',
    messages: 'Сообщение',
    andijan: 'Андижан',
    bukhara: 'Бухара',
    ferghana: 'Фергана',
    Jizzakh: 'Джизак',
    Namangan: 'Наманган',
    Navai: 'Навои',
    Kashkadarya: 'Кашкадарья',
    Karakalpakstan: 'Республика Каракалпакстан',
    Samarqand: 'Самарканд',
    Syrdarya: 'Сырдарья',
    Surkhandarya: 'Сурхандарья',
    Tashkent_reg: 'Ташкентская область',
    Tashkent_city: 'город Ташкент',
    Khorezm: 'Хорезм',
    about1: 'Качественное образование',
    about11: 'Значение качественного образования для продвижения по пути экономики знаний, требует обеспечения условий для формирования национальной инновационной системы, в рамках которой осуществляется интеграция и социальное взаимодействие государства и бизнеса.',
    about2:'Реконструкция школ',
    about21:'Реконструкция чаще всего предполагает создание либо обновление концептуальной базы, включающей социально-эстетические, педагогические, технологические, демографические аспекты региона в которой находится школа.',
    about3:'Привлечение инвесторов',
    about31:'Механизмы ГЧП позволяют привлечь частных инвесторов к реализации инфраструктурных проектов на долгосрочной основе между государственными структурами и субъектами предпринимательства. Каждая из сторон вносит свой вклад в общий проект, что позволяет достичь целей обеих сторон наиболее эффективным способом.',
    about4:'Эффективность ресурсов',
    about41:'Государственно-частное партнерство можно рассматривать как инструмент для решения таких задач современного образования, как получение образования детьми с различными образовательными потребностями; объединение и привлечение средств для улучшения качества обучающих программ.',
    about5:'Многосторонний подход',
    about51:'Многосторонний подход в проектах ГЧП позволяет всесторонне анализировать проект до его инициирования и обеспечить многогранность во время его реализации.',
    about6:'Долгосрочное развитие',
    about61:'Проекты ГЧП предусматривают сотрудничество государственного и частного секторов с целью реализации долгосрочных инвестиционных проектов в сфере народного образования на основе добровольного объединения ресурсов и распределения доходов или неимущественных выгод, расходов и рисков.',
    about0: 'Что такое ГЧП?'
}
